import { theme } from 'antd';
import { themeConfig } from '../../theme';

const { getDesignToken } = theme;

const globalToken = getDesignToken(themeConfig);

const Colors = {
  GeekBlue: globalToken.geekblue4,
  Purple7: globalToken.purple7,
  Purple5: globalToken.purple5,
  Neutral: '#BFBFBF',
  Volcano: globalToken.volcano4,
  Magenta5: globalToken.magenta5,
  Magenta7: globalToken.magenta7,
  Cyan6: globalToken.cyan6,
  Cyan7: globalToken.cyan7,
  Mint: '#379467',
  Red: globalToken.red5,
  Gold: globalToken.gold5,
  Orange: globalToken.orange6,

  Gray4: 'rgba(0, 0, 0, 0.54)',
};

export default Colors;
